import React from 'react';
import Gravatar from 'react-gravatar';

import {ApiUserProfile} from 'src/lib/api/auth';

type Props = {
  user: ApiUserProfile;
  [x: string]: any;
};

export default function Avatar({user, ...rest}: Props) {
  return <Gravatar {...rest} email={user.email} protocol="https://" />;
}
